import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onSubscriptionData"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useSubscription } from '@apollo/client';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useApolloResult } from '../use-apollo-result';
export function makeDecodedClientSideSubscription(subscription, output, input) {
  return Object.assign(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onSubscriptionData = _ref.onSubscriptionData,
        options = _objectWithoutProperties(_ref, _excluded);

    var ssrMode = false;

    var _useSubscription = useSubscription(subscription, _objectSpread(_objectSpread({
      onSubscriptionData: onSubscriptionData === undefined ? undefined : function (_ref2) {
        var subscriptionData = _ref2.subscriptionData;
        return pipe(subscriptionData.data, output.decode, onSubscriptionData);
      }
    }, options), {}, {
      skip: ssrMode || options.skip
    })),
        data = _useSubscription.data,
        loading = _useSubscription.loading,
        error = _useSubscription.error;

    var result = useApolloResult({
      data: data,
      loading: loading,
      error: error,
      output: output
    });
    return ssrMode ? O.none : O.some(result);
  }, _objectSpread({
    document: subscription,
    output: output
  }, input ? {
    input: input
  } : {}));
}